/**
 * Lightweight registry that records when each call's timer started.
 * The main CallBar writes on timer start; PiP reads to stay in sync.
 */
const startTimes = new Map<string, number>();

export function setCallTimerStart(callId: string) {
  if (!startTimes.has(callId)) {
    startTimes.set(callId, Date.now());
  }
}

export function getCallTimerStart(callId: string): number | undefined {
  return startTimes.get(callId);
}

export function clearCallTimerStart(callId: string) {
  startTimes.delete(callId);
}
